module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-b6ddb21240fd575c4a7da81e645400f8.png";